import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setPortalDashboardObject } from "../reducers/portalDashboard";

export function getPortalObject() {
  return (dispatch: any) => {
    axiosWrapper
      .get(`${getBackendUrl()}/portal/getPortalDashboardObject`)
      .then((res: any) => {
        if (res.data.status) {
          dispatch(setPortalDashboardObject(res.data.data));
        }
      })
      .catch((err: any) => {
        console.log("Error in portal dahboard object", err);
        Promise.reject(err);
      });
  };
}
